import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { DeclineReason } from '../../types';
import { ReasonConfig } from './ReasonSelector';

interface ReasonCardProps {
    reason: ReasonConfig;
    onSelect: (reason: DeclineReason) => void;
    title: string;
    subtitle: string;
}

export default function ReasonCard({
    reason,
    onSelect,
    title,
    subtitle
}: ReasonCardProps) {
    return (
        <StyledCard elevation={ 0 }>
            <CardActionArea
                onClick={ () => onSelect(reason.id) }
                aria-label={ `${ title }: ${ subtitle }` }
            >
                <Content>
                    
                    <IconWrapper>
                        { reason.icon }
                    </IconWrapper>
                    <div>
                        <Typography variant="subtitle2">
                            { title }
                        </Typography>
                        <Typography variant="caption"
                            color="text.secondary">
                            { subtitle }
                        </Typography>
                    </div>
                </Content>
            </CardActionArea>
        </StyledCard>
    );
}

// ============================================
// Styles
// ============================================

const Content = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    columnGap: theme.spacing(3)
}));

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.background.navigation
}));

const IconWrapper = styled(Box)(({ theme }) => ({
    '& .MuiSvgIcon-root': {
        fontSize: '1.2rem'
    },
    height: theme.spacing(10),
    width: theme.spacing(10),
    borderRadius: '50%',
    backgroundColor: '#eceff1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}));
